module.exports = __webpack_public_path__ + "img/icon-arrow-left-opt.6875168a.svg";